<div>
  <ng-container>
    <ui-preloader [color]="preloaderColor.blue"></ui-preloader>
  </ng-container>
</div>
